import {FC, useState, useEffect} from 'react'
import {User} from '../../core/_models'
import {useListView} from '../../core/ListViewProvider'
import {UsersListToolbar} from './UserListToolbar'
import {UsersListGrouping} from './UsersListGrouping'
import {UsersListSearchComponent} from './UsersListSearchComponent'
import {KTSVG, toAbsoluteUrl, roleQUERIES} from '../../../../../../_metronic/helpers'
import {sendInvitation} from '../../core/_requests'
import {getCustomers} from '../../../../Common/components/core/_requests'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {useQuery} from 'react-query'
import {useQueryResponse} from '../../core/QueryResponseProvider'
import clsx from 'clsx'
import toaster from '../../../../../../Utils/toaster'
import Tooltip from 'react-bootstrap/Tooltip'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import {UserListFilterDropdown} from './UserListFilterDropdown'
import Select from 'react-select'
import { useAuth } from '../../../../../modules/auth'

type Props = {
  isUserLoading?: boolean
  userType: string
  customerCode?: number
  onOpenBulkUpload?: () => void
}

const UsersListHeader: React.FC<Props> = ({userType, isUserLoading, customerCode, onOpenBulkUpload}) => {
  const [data, setData] = useState<string[]>([])
  const {setItemIdForUpdate} = useListView()
  const {refetch} = useQueryResponse()
  const [isLoading, setLoading] = useState<boolean>(false)
  const [email, setEmail] = useState<string>('')
  const {selected} = useListView()
  const editUserSchema = Yup.object().shape({
    email: Yup.string().email().min(2, 'Too Short!').max(500, 'Too Long!').required('Required'),
    fK_Customer: Yup.string().required('Required'),
  })

  const [userForEdit] = useState<User>({})
  // Export Table Ref (for future use if needed)
  // const tableRef = useState<any>(null)

  const {isFetching: isFetchingCustomer, data: responseCustomer} = useQuery(
    `${roleQUERIES.Customer_LIST}`,
    () => {
      if (!customerCode) return
      return getCustomers(userType, customerCode ?? 0)
    },
    {enabled: !!customerCode, cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false}
  )
  const customerOptions =
    !isFetchingCustomer && responseCustomer?.data
      ? responseCustomer.data.map((d) => ({value: d.key, label: d.value}))
      : []
  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
    }
    setItemIdForUpdate(undefined)
    formik.setFieldValue('email', '')
    formik.setSubmitting(false)
    formik.setFieldValue('fK_Customer', 0)
  }

  const formik = useFormik({
    initialValues: userForEdit,
    validationSchema: editUserSchema,
    onSubmit: async (values, {setSubmitting, resetForm}) => {
      setSubmitting(true)
      try {
        values.userType = userType
        var result = await sendInvitation(values)
        if (result?.status == 'S') {
          toaster('success', result?.text ?? 'Record Updated')
          resetForm()
        } else if (result?.status == 'E') {
          toaster('error', result?.text ?? 'Record Not Updated')
        }
      } catch (ex) {
        console.error(ex)
      } finally {
        formik.setFieldValue('email', '')
        formik.setFieldValue('fK_Customer', 0)
        formik.setSubmitting(false)
        formik.resetForm()
        cancel(true)
      }
    },
  })
  const {currentUser} = useAuth()

  return (
    <div className='card-header px-0 align-items-center'>
      <div className='card-title d-flex align-items-center position-relative me-4 '>
        <div className='d-flex flex-column'>
          <div className='d-flex align-items-center'>
            <h5 className='text-black fs-4 fw-semibold '>
              {' '}
              {userType == 'CONSUMER' && <> Requesters for Ad Astra Connect</>}
              {userType == 'INTERPRETER' && <>Interpreters for Ad Astra Connect</>}
              {userType == 'SYSTEM' && <> Administrators for Ad Astra Connect</>}
            </h5>
          </div>
          <div className='d-flex flex-wrap fs-6'>
            <p className='text-gray-500 mb-0 fw-normal text-capitalize' style={{fontSize: '12px'}}>
              Manage Members
            </p>
          </div>
        </div>
      </div>

      <form id='kt_modal_add_user_form' className='form' onSubmit={formik.handleSubmit} noValidate>
        <div className='card-toolbar'>
          <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
            <div className='modal-dialog'>
              <div className='modal-content'>
                <div className='modal-header py-2'>
                  <h4 className='modal-title'>Invite Your Team</h4>
                  <div
                    className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                    data-bs-dismiss='modal'
                    aria-label='Close'
                    onClick={() => {
                      formik.setFieldValue('email', '')
                      formik.setFieldValue('fK_Customer', 0)
                      formik.setSubmitting(false)
                      formik.resetForm()
                      cancel(false)
                    }}
                  >
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr061.svg'
                      className='svg-icon svg-icon-2x'
                    />
                  </div>
                </div>
                <div className='modal-body'>
                  <div className='row g-4 g-xl-6'>
                    <div className='col-sm-12 col-md-12 col-lg-12'>
                      <div className=''>
                        <label htmlFor='exampleFormControlInput1' className='form-label'>
                          Add e-mail address of user you wish to invite
                        </label>
                        <div className='row g-4 g-xl-6 d-flex align-items-center'>
                          <div className='fv-row '>
                            <div className='row '>
                              <div className='col-lg-12 mb-1 fv-row'>
                                <label className='col-lg-6 col-form-label required  fw-bold fs-6'>
                                  Email
                                </label>
                                <input
                                  placeholder='Enter Email Address'
                                  {...formik.getFieldProps('email')}
                                  className={clsx(
                                    'form-control form-control-white form-select-sm mb-2',
                                    {'is-invalid': formik.touched.email && formik.errors.email},
                                    {
                                      'is-valid': formik.touched.email && !formik.errors.email,
                                    }
                                  )}
                                  type='email'
                                  name='email'
                                  autoComplete='off'
                                  disabled={formik.isSubmitting}
                                />
                                {formik.touched.email && formik.errors.email && (
                                  <div className='fv-plugins-message-container'>
                                    <div className='fv-help-block'>
                                      <span role='alert'>{formik.errors.email}</span>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className='col-lg-12  mb-1 fv-row'>
                                <label className='col-lg-6 col-form-label required fw-bold fs-6'>
                                  Customer
                                </label>
                                <div className='row'>
                                  <div className='col-lg-12 fv-row'>
                                    <Select
                                      {...formik.getFieldProps('fK_Customer')}
                                      name='fK_Customer'
                                      placeholder='Select a customer'
                                      value={
                                        customerOptions.find(
                                          (option) => option.value === formik.values.fK_Customer
                                        ) || null
                                      }
                                      onChange={(option: {value: any}) => {
                                        formik.setFieldValue('fK_Customer', option?.value || '')
                                      }}
                                      isDisabled={formik.isSubmitting || isUserLoading}
                                      options={customerOptions}
                                    />
                                    {formik.touched.fK_Customer && formik.errors.fK_Customer && (
                                      <div className='fv-plugins-message-container'>
                                        <div className='fv-help-block'>
                                          <span role='alert'>{formik.errors.fK_Customer}</span>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className='col-sm-12 col-md-12 col-lg-12'>
                      <div className='table-responsive'>
                        <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'>
                          <thead>
                            <tr className='fw-semibold text-muted text-uppercase'>
                              <th className='min-w-150px '>Email</th>
                              <th className='min-w-100px text-end'>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {!isLoading && data.map((d, key) => (
                              <tr>
                                <td>
                                  <a className='text-gray-800 text-hover-primary fs-6'>
                                    {d}
                                  </a>
                                </td>

                                <td>
                                  <div className='d-flex justify-content-end flex-shrink-0'>
                                    <button onClick={(e) => func_removeemail(d)}
                                      className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
                                      type='button'
                                    >
                                      <KTSVG
                                        path='/media/icons/duotune/general/gen027.svg'
                                        className='svg-icon-3'
                                      />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))}


                          </tbody>
                        </table>
                      </div>
                    </div> */}
                  </div>
                </div>
                <div className='modal-footer py-3'>
                  <button
                    type='button'
                    className='btn btn-light btn-sm'
                    data-bs-dismiss='modal'
                    aria-label='Close'
                    onClick={() => {
                      formik.setFieldValue('email', '')
                      formik.setFieldValue('fK_Customer', 0)
                      formik.setSubmitting(false)
                      formik.resetForm()
                      cancel(false)
                    }}
                  >
                    Close
                  </button>
                  <button
                    type='submit'
                    className='btn btn-sm btn-primary'
                    data-bs-dismiss='modal'
                    data-kt-users-modal-action='submit'
                    disabled={isUserLoading || formik.isSubmitting || !formik.isValid}
                  >
                    <span className='indicator-label'>Send Invitation</span>
                    {(formik.isSubmitting || isUserLoading) && (
                      <span className='indicator-progress'>
                        Please wait...{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className='modal fade' tabIndex={-1} id='kt_modal_2'>
            <div className='modal-dialog'>
              <div className='modal-content'>
                <div className='modal-body'>
                  <div className='row g-4 g-xl-6'>
                    <div className='col-sm-12 col-md-12 col-lg-12'>
                      <div className='text-center'>
                        <KTSVG
                          path='/media/icons/duotune/general/gen044.svg'
                          className='svg-icon-info svg-icon-5hx'
                        />
                        <h1>Confirmation</h1>
                        <span> Are you sure you'd like to re-invite all individuals?</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='modal-footer py-3'>
                  <button type='button' className='btn btn-light btn-sm' data-bs-dismiss='modal'>
                    Cancel
                  </button>
                  <Link to='#'>
                    <button
                      type='button'
                      className='btn btn-primary btn-sm'
                      data-bs-dismiss='modal'
                    >
                      Re-Invite
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex align-items-center position-relative'>
            <UsersListSearchComponent userType={userType} customerCode={customerCode} />
          </div>
          <div>
            {userType == 'CONSUMER' && (
              <OverlayTrigger
                placement='top'
                overlay={<Tooltip id='tooltip-filter'>Send Invitation</Tooltip>}
              >
                <div>
                  <button
                    type='button'
                    className='btn btn-sm btn-primary btn-icon ms-3'
                    data-bs-toggle='modal'
                    data-bs-target='#kt_modal_1'
                  >
                    <KTSVG
                      path='/media/icons/duotune/general/gen016.svg'
                      className='svg-icon-muted'
                    />
                  </button>
                </div>
              </OverlayTrigger>
              // <button
              //   type='button'
              //   className='btn btn-sm btn-primary me-2'
              //   data-bs-toggle='modal'
              //   data-bs-target='#kt_modal_1'
              // >
              //   <i className='bi bi-person-fill me-2'></i>Send Invitation
              // </button>
            )}
          </div>
          <div className='ms-3'>
            <UserListFilterDropdown userType={userType} customerCode={customerCode ?? 0} />
          </div>
          <div className='ms-3'>
            {currentUser?.result.userType === 'SYSTEM' && (
              <OverlayTrigger
                placement='top'
                overlay={<Tooltip id='tooltip-export'>Export to CSV</Tooltip>}
              >
                <button
                  type='button'
                  className='btn btn-sm btn-primary btn-icon'
                  onClick={() => {
                    if (window && window.dispatchEvent) {
                      window.dispatchEvent(new CustomEvent('export-users-table'))
                    }
                  }}
                >
                  <KTSVG path='/media/icons/duotune/files/fil017.svg' className='svg-icon-muted' />
                </button>
              </OverlayTrigger>
            )}
          </div>
          <div>
            {selected.length > 0 ? <UsersListGrouping /> : <UsersListToolbar userType={userType} onOpenBulkUpload={onOpenBulkUpload} />}
            {/* <button
              type='button'
              className='btn btn-sm btn-primary fs-6'
              data-bs-toggle='modal'
              data-bs-target='#kt_modal_2'
            >
              <i className='bi bi-people-fill me-2'></i> Invite All
            </button> */}
          </div>
        </div>
      </form>
    </div>
  )
}

export {UsersListHeader}
